import React from "react";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import AxiosInstance from "../../AxiosInstance";
import { alertError } from "../Helper/Alerts";
import { useState } from "react";
import { Button, Result } from "antd";
import Loading from "../Helper/loading";
import OtherPageHeader from "../../components/OtherHeader";

export default function Response() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [response, setResponse] = useState({});
  useEffect(() => {
    getOrderStatus();
  }, []);
  const getOrderStatus = () => {
    AxiosInstance()
      .get("/order/" + searchParams.get("orderId"))
      .then((resp) => {
        loadResponse(resp.data.data);
      })
      .catch((error) => {
        alertError(error.response.data.message);
      });
  };
  const loadResponse = (data) => {
    console.log(data);

    let sum = {};
    switch (data.status) {
      case "CONFIRMED":
        sum.status = "success";
        sum.title = "Payment Recieved Successfully!";
        sum.subTitle = (
          <span>
            Order Id: {" " + data?.orderId} , Transaction Id:
            {" " + data?.paymentTransactionId} <br></br>Our Customer Support
            will contact you soon.
          </span>
        );
        break;

      case "PAYMENT_AWAITED":
        sum.status = "warning";
        sum.title = "Payment Awaited!";
        sum.subTitle = (
          <span>
            Order Id: {" " + data?.orderId} , Transaction Id:
            {" " + data?.paymentTransactionId} <br></br>Our Customer Support
            will contact you soon.
          </span>
        );
        break;

      default:
        sum.status = "";
        sum.title = "";
        sum.subTitle = (
          <span>
            Order Id: {" " + data?.orderId} , Transaction Id:
            {" " + data?.paymentTransactionId} <br></br>Our Customer Support
            will contact you soon.
          </span>
        );

        break;
    }
    setResponse(sum);
  };

  return !response ? (
    <Loading></Loading>
  ) : (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
      />
      <div className="">
        {" "}
        <Result
          status={response.status}
          title={response?.title}
          subTitle={response?.subTitle}
          extra={[
            <Button
              type="primary"
              key="console"
              onClick={() => {
                window.location.href = "/investordashboard";
              }}
            >
              Go to Console
            </Button>,
          ]}
        />
      </div>

    </div>
  );
}
